import { routes } from '@communities/routes';
import { withAppInsightsTracking } from '@core/logging/withAppInsightsTracking';
import { Button, ButtonSize, ButtonType, Heading, Section } from '@soteria/design-system-ve';
import { useNavigate } from 'react-router-dom';

interface CaseSearchTabProps {
  communityId: string;
}

/**
 * Case Search tab component for community management
 * Provides navigation to the case search page
 */
function CaseSearchTabComponent({ communityId }: CaseSearchTabProps) {
  const navigate = useNavigate();

  const handleNavigateToCaseSearch = () => {
    navigate(routes.communities.caseSearch.root(communityId));
  };

  return (
    <Section spacing="large">
      <div>
        <Heading level="h2">Case Search</Heading>
        <p>Search for moderation cases by User ID and other criteria.</p>
        <Button buttonSize={ButtonSize.Default} buttonType={ButtonType.Brand} label="Go to Case Search" onClick={handleNavigateToCaseSearch} />
      </div>
    </Section>
  );
}

export const CaseSearchTab = withAppInsightsTracking(CaseSearchTabComponent, 'CaseSearchTab');
